import React from 'react';
import industries from '../assets/images/industries.png';
import DynamicSlider from '../components/DynamicSlider';
import TextBanner from '../components/TextBanner';
import { Container, Row, Col } from 'react-bootstrap';

import designer from '../assets/images/animated_video1.png';
import dance from '../assets/images/animated_video2.png';
import redteam from '../assets/images/animated_video3.png';
import developer from '../assets/images/whoslider4.png';
import IndustriesData from './IndustriesData';

import Footer from '../Footer/Footer';
import Getintouch from '../Gettouch/Getintouch';

const Industries = () => {


    // banner conter
    const sliderItems = [
        {
          image: designer,
          alt: 'Designer',
          title: 'Designer Team',
          description: 'Designer Team Description for Slider Item'
        },
        {
          image: dance,
          alt: 'Dance',
          title: 'Dance Team',
          description: 'Dance Team Description for Slider Item'
        },
        {
        image: developer,
        alt: 'developer',
        title: 'developer team',
        description: 'Developer Team Description for Slider Item 3'
        },
        {
          image: redteam,
          alt: 'redcube',
          title: 'redcube team',
          description: 'Redcube team Description for Slider Item 3'
        }
        
      ];



  return (
    <>
         {/* new banner dynamic */}
         <TextBanner
              imageUrl={industries}
              altname="Industries"
              title="We speak your industry's language digitally. "  
            />
        {/*  new banner dynamic end */}
      

       
        {/* top slider  */}

          <DynamicSlider sliderItems={sliderItems} />

        {/* top slider  */}


        {/* Building Brands & Driving Leads  */}

        <section>
            <Container>
            <h1 class="Imagine_center">Building Brands & Driving Leads </h1>


            <Row>
            <IndustriesData />
            </Row>
           
            </Container>
          </section>

    {/* Building Brands & Driving Leads  */}








       

        <section>
            <div class="container">    
                <div class="row">
                    <Col lg={12}>
                    <p class="choose_make">Choose your industry, and let's make a digital impact together! </p>
                    </Col>
                </div>
            </div>               
        </section>

         {/* get in touch */}
      <section className='p-0'>
        <Getintouch />
      </section>

      {/* Footer  */}
      <section className='p-0' >
        <Footer />
      </section>


      
    </>
  )
}

export default Industries
